export function average(values: number[]): number {
  return values?.reduce((acum, value) => (acum += value), 0) / values?.length;
}
